<template>
    <section :class="$style['mds-search-results__section']">
        <mds-section border="primary" :title="title" :size="8" bold>
            <template #mds-section-actions>
                <slot name="mds-search-results-section-actions"></slot>
            </template>
            <slot></slot>
        </mds-section>
    </section>
</template>

<script>
    import MdsSection from '@mds/section';

    export default {
        name: 'MdsSearchResultsSection',
        components: {
            MdsSection,
        },
        props: {
            title: {
                type: String,
                required: true,
                docs: {
                    validation: '**Required**',
                    description: 'Sets the search results section&rsquo;s header text.',
                },
            },
        },
    };
</script>

<style lang="scss" module>
    @import './search-results.scss';
</style>
